import * as Types from '../../../../../gql/types.generated';

import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrderQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type OrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: string, sandType: string, timezone: string, status: string, timeBetweenTrucks: number, trucks: Array<number>, units?: string | null, colorBag: { __typename?: 'OrderPreparatoryConfigSandColorOption', pricePerBag: number, totalPrice: number, colorPercentageOption: number, numberOfBags: string }, partner?: { __typename?: 'Partner', id: string } | null, supplier: { __typename?: 'Supplier', id: string }, plant: { __typename?: 'Plant', id: string, name: string }, deliveryMethod: { __typename?: 'DeliveryMethod', id: string, name: string, caption?: string | null, description?: string | null }, trucksDrivers: Array<{ __typename?: 'OrderTruck', id: number, truckId: string, deliveryTime?: string | null, deliveryItems: Array<{ __typename?: 'OrderDeliveryItem', id?: string | null, quantity: number, units?: string | null, productType: { __typename?: 'ProductType', name: string, id: string, group?: string | null } }>, driver?: { __typename?: 'Driver', id: string, info: { __typename?: 'DriverInfo', name?: string | null } } | null, truck?: { __typename?: 'Truck', id: string, name: string, type: string } | null, plant?: { __typename?: 'Plant', id: string, name: string } | null }>, product: { __typename?: 'ProductCategory', id: string, industry: string, permissions: { __typename?: 'ProductCategoryPermissions', trucks: boolean } }, prices: Array<{ __typename?: 'OrderPrice', id?: string | null, value: number, quantity?: number | null, anchorPrice?: { __typename?: 'OrderPrice', id?: string | null } | null, productDecorate?: { __typename?: 'ProductDecorate', id: string, name: string } | null, fee?: { __typename?: 'Fee', id: string, name: string } | null, option?: { __typename?: 'Option', id: string, name: string } | null, price: { __typename?: 'Price', id?: string | null, value: number, content: string }, productType?: { __typename?: 'ProductType', id: string, name: string } | null }> }, orderPreparatoryConfig: { __typename?: 'OrderPreparatoryConfig', trucksConfig: { __typename?: 'TrucksConfig', deliveryMethod: { __typename?: 'DeliveryMethod', id: string, name: string, caption?: string | null, description?: string | null }, count: { __typename?: 'TrucksConfigCountType', max: number }, quantity: { __typename?: 'TrucksConfigQuantityType', min: number, max: number, step: number } }, trucksConfigs: Array<{ __typename?: 'TrucksConfig', deliveryMethod: { __typename?: 'DeliveryMethod', name: string, caption?: string | null, description?: string | null }, count: { __typename?: 'TrucksConfigCountType', max: number }, quantity: { __typename?: 'TrucksConfigQuantityType', min: number, max: number, step: number } }> } };


export const OrderDocument = gql`
    query order($id: ID!) {
  order(id: $id) {
    id
    sandType
    colorBag {
      pricePerBag
      totalPrice
      colorPercentageOption
      numberOfBags
    }
    timezone
    status
    partner {
      id
    }
    supplier {
      id
    }
    plant {
      id
      name
    }
    deliveryMethod {
      id
      name
      caption
      description
    }
    timeBetweenTrucks
    trucks
    units
    trucksDrivers {
      deliveryItems {
        id
        productType {
          name
          id
          group
        }
        quantity
        units
      }
      id
      truckId
      deliveryTime
      driver {
        id
        info {
          name
        }
      }
      truck {
        id
        name
        type
      }
      plant {
        id
        name
      }
    }
    product {
      id
      industry
      permissions {
        trucks
      }
    }
    prices {
      id
      value
      quantity
      anchorPrice {
        id
      }
      productDecorate {
        id
        name
      }
      fee {
        id
        name
      }
      option {
        id
        name
      }
      price {
        id
        value
        content
      }
      productType {
        id
        name
      }
    }
  }
  orderPreparatoryConfig(order: {id: $id}) {
    trucksConfig {
      deliveryMethod {
        id
        name
        caption
        description
      }
      count {
        max
      }
      quantity {
        min
        max
        step
      }
    }
    trucksConfigs {
      deliveryMethod {
        name
        caption
        description
      }
      count {
        max
      }
      quantity {
        min
        max
        step
      }
    }
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;


export function useOrderRequest() {
    const client = useApolloClient();
    return useCallback<(variables: OrderQueryVariables, options?: Omit<Apollo.QueryOptions, 'query'>) => Promise<Apollo.ApolloQueryResult<OrderQuery>>>( (variables, options) => {
        return client.query<OrderQuery>({
            fetchPolicy: 'no-cache',
          ...options,
          query: OrderDocument,
          variables
        })
    }, []);
}

